module.exports = __webpack_public_path__ + "media/Polos_Mobile.97a582e4.mp4";